const tabsChecklistQuestions = {
  TabLabel1: 'QUESTION DETAILS',
  TabLabel2: 'DESCRIPTIVE IMAGE',
  TabLabel3: 'OTHER OPTIONS',
};

export default tabsChecklistQuestions;
